import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { colors } from "healthex-common/colors";
import { HXMobileButton } from "./HXButton";
import React from "react";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Launch from "@mui/icons-material/Launch";
export const ReauthSteps = styled(FlexColumnDiv) `
    padding: 16px 8px;
    gap: 8px;
    justify-content: flex-start;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
`;
export const ReauthStepsList = styled.ol `
    margin: 0;
    padding-left: 21px;
    li {
        margin-bottom: 8px;
    }
    li:last-child {
        margin-bottom: 0;
    }
`;
export const ReauthLoginButton = styled(HXMobileButton).attrs({
    endIcon: React.createElement(Launch),
    component: "label",
}) `
    min-width: 96px;
`;
export const ReauthLoginButtonFullWidth = styled(ReauthLoginButton) `
    width: 100%;
`;
export const ReauthSuccessButton = styled(HXMobileButton).attrs({
    color: "success",
    disableElevation: true,
    disableRipple: true,
    startIcon: React.createElement(CheckCircle),
    component: "label",
    sx: {
        ml: 1,
        "&.MuiButtonBase-root": {
            bgcolor: colors.chips_forest,
            cursor: "default",
        },
        "&.MuiButtonBase-root:hover": {
            bgcolor: colors.chips_forest,
        },
    },
}) `
    background-color: ${colors.chips_forest};
    cursor: default;
    &:hover {
        background-color: ${colors.chips_forest};
    }
`;
export const ReauthSuccessButtonFullWidth = styled(ReauthSuccessButton) `
    width: 100%;
`;
